import React from 'react'
import ProjectStep from "./../components/ProjectStep";


export default class TimingStep extends ProjectStep
{
    static TranslationKey = 'timing_step';

    static path = '/kickoff';
    static slug = 'kickoff';


    static ValidationMethodName = 'validateTiming';

    static hasCompleted(project) {
        return project.validateTiming();
    }

    /**
     * @param {Project} project
     * @returns {Object}
     */
    static reviewMapping(project) {

        let timing = {
            ['Starts']: project.startRangeName(),
        }

        if (TB.isDefined(project.weeks_to_finish)){
            timing['Est. Duration'] = project.weeks_to_finish + ' Weeks';
        }
        if (TB.isDefined(project.delivery_date)){
            let delivery = project.delivery_date.toISOString();

            timing['Desired Delivery Date'] = TB.moment(delivery).format('ll');
        }

        return {
            ['Project Timing']: timing
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {

        let endDate = this.props.project.startRangeDate() || TB.moment().add('weeks', 1).toDate();

        let serviceFields = {}
        if ( !this.props.project.isBYO() ) {
            serviceFields = {
                time_range_header:    <label className="col-form-label-hint">
                    {this.translate('time_range_step_label')}
                </label>,
                weeks_to_finish: {
                    type: 'number',
                    max: 52,
                    label: this.translate('time_range_question'),
                    reviewLabel: this.translate('time_range_review_label'),
                    required: !TB.isDefined(this.props.project.delivery_date),
                    placeholder: 'Enter number of weeks',
                    min: 1,
                    validation: {
                        rules: {
                            matchRegexp: /^([1-9]|[1-4][0-9]|5[0-2])$/,
                            isInt: true
                        },
                        errors: {
                            isInt: TB.trans('validation.integer', {
                                'attribute': 'weeks to finish'
                            }),
                            matchRegexp: 'The weeks to finish must be between 1 and 52 weeks.',
                        }
                    },
                    validationErrors: this.defaultRequiredValidation("target completion")
                },
                time_range_option: (
                    <p className="create-project-form-field-question mt-2 mb-4">
                        or
                    </p>
                ),
                delivery_date: {
                    type: 'date',
                    label: 'Choose a desired delivery date',
                    required: false,
                    minDate: endDate,
                    showCalendar: true,
                    columns: 4
                }
            }
        }
        return [
            {
                header: this.translate('start_range_step_label'),
                fields: {
                    start_range: {
                        label: this.translate('start_range_question'),
                        reviewLabel: this.translate('start_range_review_label'),
                        type: 'radio',
                        required: true,
                        options: laravel.project_start_ranges,
                        validationErrors: this.defaultRequiredValidation("project start")
                    },
                    ...serviceFields
                }
            },

        ];
    };

    mapping(params) {

        let model = {...params};

        if(typeof model.delivery_date === 'string') {
            model.delivery_date = new Date(model.delivery_date).toISOString()
        }else if (model.delivery_date instanceof Date) {
            model.delivery_date = model.delivery_date.toISOString()
        }

        if (!TB.isNaN(parseInt(model.weeks_to_finish))) {
            model.weeks_to_finish = parseInt(model.weeks_to_finish)
        }

        return model;
    }


    async onChange(params) {

        let change = {};
        if (TB.isDefined(this.props.project.weeks_to_finish) &&
            this.props.project.weeks_to_finish !== '' && TB.isDefined(params.delivery_date)
        ) {
            change.weeks_to_finish = '';
        }
        if (
            TB.isDefined(this.props.project.delivery_date) &&
            this.props.project.delivery_date !== '' && TB.isDefined(params.weeks_to_finish)
        ) {
            change.delivery_date = '';
        }
        super.onChange(params)

        if (Object.keys(change).length) {
            await this.formRef.current.updateInputsWithValue(change, false);
        }
    }
}